import { Loader2 } from "lucide-react";

const STYLES = {
  PASS: "pill-pass",
  FAIL: "pill-fail",
  RUNNING: "pill-running",
  IDLE: "pill-idle",
};

export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className={`pill ${STYLES[status] || STYLES.IDLE}`}>
    {status === "RUNNING" && <Loader2 size={11} className="animate-spin" />}
    {status === "IDLE" ? "IDLE" : status}
  </span>
);
